module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_desktop1-7a657555f9b6849e07e957138d70ea37.jpg";